/**
 * @prettier
 */
import { BuyOrderStatuses } from 'src/constants/BuyOrderStatus';
import type { BuyOrderVm } from 'src/types/BuyOrderVm';

export function isBuyOrderCancelled(buyOrder: BuyOrderVm): boolean {
    return !!buyOrder && buyOrder?.buyOrderStatus === BuyOrderStatuses.CANCELLED;
}
